module.exports = __webpack_public_path__ + "static/media/exitIcon.d9f2d1ee.svg";